<template>
  <div class="scroll-tab-area">
    <div
      class="web-tab-wrap"
      ref="tabWrap"
      @mousedown="onMouseDown"
      @mousemove="onMouseMove"
      @mouseup="onMouseUp"
      @mouseleave="onMouseUp"
    >
      <button
        v-for="(item, itemIndex) in items"
        :key="`item_${itemIndex}`"
        type="button"
        :class="{ tab: true, on: item.isChecked }"
        @click="handleItem(item)"
      >
        {{ t(item.label) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { SearchFilter } from '@/types/components';

const items = defineModel<SearchFilter[]>({
  required: true,
  default: () => [],
});
const emit = defineEmits<{ change: [] }>();

const { t } = useI18n();

// pc 드래그 스크롤링 추가
const tabWrap = ref<HTMLDivElement | null>(null);
const isDragging = ref(false);
const startX = ref(0);
const scrollLeft = ref(0);
const hasDragged = ref(false);

function onMouseDown(e: MouseEvent) {
  if (!tabWrap.value) return;
  isDragging.value = true;
  hasDragged.value = false;
  startX.value = e.pageX - tabWrap.value.offsetLeft;
  scrollLeft.value = tabWrap.value.scrollLeft;
  tabWrap.value.style.cursor = 'grabbing';
}

function onMouseMove(e: MouseEvent) {
  if (!isDragging.value || !tabWrap.value) return;
  e.preventDefault();
  const x = e.pageX - tabWrap.value.offsetLeft;
  const walk = x - startX.value;
  if (Math.abs(walk) > 5) hasDragged.value = true;
  tabWrap.value.scrollLeft = scrollLeft.value - walk;
}

function onMouseUp() {
  if (!tabWrap.value) return;
  isDragging.value = false;
  tabWrap.value.style.cursor = 'grab';
}

// 클릭 + 드래그 방지 통합
function handleItem(selectedItem: SearchFilter) {
  if (hasDragged.value) return;

  items.value.forEach((item) => {
    item.isChecked = item === selectedItem;
  });

  emit('change');
}
</script>

<style scoped>
.wrapper-checkbox {
  display: flex;
  gap: 1rem;
  width: 100%;
}
</style>
